// extracted by mini-css-extract-plugin
export default {"wrapper":"nQZ8y5BUZkUEYnNTV2AT","detailsWrapper":"bmGC5Fe02Pmk4eHapSKJ","tagWrapper":"M6uvnzXgF2v7I7LO3hOc","actionButton":"XluqpUQ9ROQdhAExerab"};